import LearnAboutPrepayAndPayLaterModal from './LearnAboutPrepayAndPayLaterModal';

export default LearnAboutPrepayAndPayLaterModal;
